import {productSchema} from "../../services/rich-snippets/product-schema";

require("react");
import { useCallback, useMemo, useEffect, useState, memo } from 'react';
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { styled } from '@mui/system';
import { Dialog, DialogTitle } from '@mui/material';
import { useTranslation } from "next-i18next";
import { useDispatch } from 'react-redux';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import cookies from 'next-cookies';
import Link from "next/link";
import { Autocomplete, TextField } from '@mui/material';
import replaceall from 'replaceall';
import axios from 'axios';
import SelectedMastersMobile from "../../components/CardsCont/SelectedMastersMobile";
import SelectedMasters2 from '../../components/CardsCont/SelectedMasters2';
import MainButton from "../../components/ButtonsCont/MainButton";
import CitiesList from '../../components/CitiesList';
import { getLatLong } from '../../utils/getDistance';
import translate_word from '../../utils/translate';
import authApi from "../../services/authinstance";
import MainLayout from "../../Layouts/MainLayout";
import hooks from "../../hooks/masterHooks";
import keys from "../../services/keys";
import { wrapper } from '../../store';
import styles from '../../styles/Masters2.module.scss';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import LoadingLayer from '../../components/LoadingLayer/LoadingLayer';
import CustomDayPicker from '../../components/CustomDayPicker';
import { get_closest_masters_posts, set_closest_cities } from '../../store/actions/master';
import CustomTimePicker from '../../components/CustomTimePicker';
import MastersPost from '../../components/MastersPost';
import Slider from 'react-slick';
import SwitchCont from '../../components/Switch/SwitchCont';
import {get_master} from "../../store/actions/service";
import {makeAbsolute} from "../../utils/urlHelpers";
// import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
// import replaceall from 'replaceall';

// const LabelComponent = ({
//     onClick,
//     item,
//     user,
//     code }) => {
//     return <div className="marker" onClick={() => {
//         onClick();
//     }}>
//         <div className="label-hover">
//             <MyInfo
//                 user={user}
//                 image={item.image}
//                 last_name={item.user.first_name}
//                 first_name={item.user.last_name}
//                 // service_name={item.service_name
//                 //     ? translate_word(item.service_name, code)
//                 //     : ""}
//                 review_count={item.review_count}
//                 rating={item.rating}
//             />
//         </div>
//         <img
//             style={{ width: '35px', height: '35px', borderRadius: '50px', objectFit: "cover" }}
//             src={item.image ? item.image : '/profile-user.svg'}
//         />
//         {/* <i className="icon-map-label"></i> */}
//         <div className="label-item" />
//     </div>;
// };
const GroupHeader = styled('div')(({ theme }) => ({
    position: 'sticky',
    top: '-8px',
    padding: '4px 10px',
    color: '#F9989C',

}));

const GroupItems = styled('ul')({
    padding: 0,
});

const DEFAULT_LAT = 48.864716;
const DEFAULT_LNG = 2.349014;

export const getServerSideProps = wrapper.getServerSideProps(async (ctx) => {
    const { token, lat, lng, sub_category } = cookies(ctx);
    let notFoundCity = false;
    let cityTitle = null;
    try {
	const all = Array.isArray(ctx.query.all) ? ctx.query.all : [];
        const subCategorySlugFromUrl = all[0] || null;
        const citySlug = ctx.query.city || null;
        // const mastersPosts = getClosestCities.data? await authApi.post(`${keys.SERVER_URL}timeline/masters-posts/`, {
        //     "masters":getClosestCities.data.map((el)=>el?.id)
        // }):null;
        const isSubCategory = subCategorySlugFromUrl && subCategorySlugFromUrl !== 'null';
	const [descriptionTexts, responseSubCategory] = await Promise.all([
            axios.get(`${keys.SEO_SERVER_URL}utils/template/`),
            isSubCategory
                ? authApi.get(`${keys.SEO_SERVER_URL}utils/sub-category/?slug=${subCategorySlugFromUrl}`)
                : authApi.get(`${keys.SEO_SERVER_URL}utils/sub-category/`)
        ]);
	
	let subCategoryId = null;
        let latitude = parseFloat(lat) || DEFAULT_LAT;
        let longitude = parseFloat(lng) || DEFAULT_LNG;
	
        if (citySlug) {
            const responseCity = await axios.get(`${keys.SEO_SERVER_URL}utils/city/?slug=${citySlug}`);
            const cityData = responseCity?.data?.results?.[0] || {};
            cityTitle = cityData[`title_${ctx.locale || 'fr'}`]

            subCategoryId = responseSubCategory.data?.results?.[0]?.id;
            latitude = parseFloat(cityData.latitude) || latitude;
            longitude = parseFloat(cityData.logitude) || longitude;
	    
	    const [responseMasters, responseClosestCities] = await Promise.all([
                authApi.post(`${keys.SERVER_URL}schedule/get-all-free-masters/`, {
                    sub_category: subCategoryId,
                    lat: latitude,
                    long: longitude
                }),
                authApi.post(`${keys.SEO_SERVER_URL}utils/get-closest-cities/`, {
                    latitude,
                    longitude,
                    num_cities: 10
                })
            ]);

            ctx.store.dispatch(get_master({ results: responseMasters.data, mapData: [latitude, longitude], mapZoom: 12 }));
	    ctx.store.dispatch(set_closest_cities(responseClosestCities?.data));
        }

        const subCategorySlug = responseSubCategory.data?.results?.[0]?.[`slug_${ctx.locale}`]

        if (isSubCategory && subCategorySlug && subCategorySlug !== subCategorySlugFromUrl) {
	    const destination = `/${ctx.locale}/masters/${subCategorySlug}${citySlug ? `/?city=${citySlug}` : ''}`
            return {
                redirect: {
                    permanent: false,
                    destination
                }
            }
        }
	if ('city' in ctx.query && !ctx.query.city) {
            notFoundCity = true;
        }
        const textId = () => {
            if (citySlug && responseSubCategory.data) return 2;
            if (citySlug) return 0;
            if (responseSubCategory.data) return 1;
            return null;
        };
        
        return {
            props: {
                ...(await serverSideTranslations(ctx.locale, ["common"])),
                lat: latitude,
                lng: longitude,
                sub_category: sub_category ?? null,
                token: token ?? null,
                loggedIn: true,
                language: ctx.locale || 'fr',
                city: cityTitle,
                slug: citySlug,
                absoluteUrl: makeAbsolute(ctx.req) || '',
                notFoundCity,
                service: subCategorySlugFromUrl ? subCategorySlugFromUrl.replace(/-/g, ' ') : null,
                from_date: ctx.query.from_date ?? '',
                to_date: ctx.query.to_date ?? '',
                from_time: ctx.query.from_time ?? '',
                to_time: ctx.query.to_time ?? '',
                go_home: ctx.query.go_home === 'true',
                currentService: responseSubCategory.data?.results?.[0] ?? '',
                descriptionTexts: descriptionTexts?.data?.results?.[textId()] ?? null,
                //getClosestCities: getClosestCities?.data ?? '',
                // mastersPosts:mastersPosts?.data

            }
        };
    } catch (error) {
        // ctx.store.dispatch(get_master({ results: [], ...ctx.query, page: parseInt(ctx.query.page) + 1 }));
	const all = Array.isArray(ctx.query.all) ? ctx.query.all : [];
	return {
            props: {
                ...(await serverSideTranslations(ctx.locale, ["common"])),
                items: null,
                sub_category: sub_category ?? null,
                token: token ?? null,
                loggedIn: true,
                language: ctx.locale || 'fr',
                city: null,
                slug: ctx.query.city || null,
                absoluteUrl: makeAbsolute(ctx.req) || '',
                service: all[1] || null,
                lat: lat ?? null,
                lng: lng ?? null,
                from_date: ctx.query.from_date ?? '',
                to_date: ctx.query.to_date ?? '',
                from_time: ctx.query.from_time ?? '',
                to_time: ctx.query.to_time ?? '',
                go_home: ctx.query.go_home === 'true',
                notFoundCity,
                // currentService: responseSubCategory.data.results[0] ?? '',
                cityError: error?.response?.data?.message === 'City matching query does not exist.' ? true : false
                // objectData
            }
        };
    }
    // }
});
const queryString = require('query-string');
function Masters(props) {
    const {
        masters_data,
        translate,
        settings,
        user,
        mapRef,
        show_map,
        city_position,
        my_city,
        category_array,
        service_data,
        open,
        closestCities,
        closestMastersPosts,
        center,
        posts_slider,
        handleClose,
        // setMapRef,
        // map, maps,
        setPosition,
        master_saga_act,
        add_favorite_masters,
        remove_favorite_masters,
        handleClick,
        get_room,
        get_city_by_search
    } = hooks(props);
    const settingsFirstSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 'ppp',
        arrows: true,
    };
    const settingsSecondSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 'ppp',
        arrows: true,
    };
    const [startDate, setStartDate] = useState(props.from_date ? new Date(props.from_date) : '');
    const [endDate, setEndDate] = useState(props.to_date ? new Date(props.to_date) : '');
    const [selectedTime, setSelectedTime] = useState({ from: props?.from_time, to: props?.to_time });
    const [city, setCity] = useState(props.city);
    const [goHome, setGoHome] = useState(props.go_home);
    // const [selectedService, setSelectedService] = useState();
    // const [selected, setSelected] = useState();
    // const [time, setTime] = useState(props.time ? parse(props.time, 'HH:mm:ss', new Date()) : null);
    const [loading, setLoading] = useState(false);
    // const [inClientSide, setInClientSide] = useState(false);
    const WAIT_INTERVAL = 1000;
    let timer;
    const { t, i18n } = useTranslation();

    const dispatch = useDispatch();
    // const handleSwirchClient = useCallback(() => { setInClientSide(true); }, []);
    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    const defaultProps = {
        center: {
            lat: 10.99835602,
            lng: 77.01502627
        },
        zoom: 11
    };
    var my_map;
    // useEffect(() => {
    //     timer = null;
    //     handleSwirchClient();
    // }, []);
    useEffect(() => {
        const selected_city = city ? city : props.city
        getLatLong(selected_city, (item) => {
            setPosition(item);
        });
    }, [props.city, city]);
    // const handleChangeService = useCallback((value) => {
    //     setSelectedService(value);
    // }, []);
    const handleSelectTime = useCallback((e) => {
        setSelectedTime(e);
        setLoading(true)
        // dispatch(get_master_loading());
        pushRouter({
            from_time: e.from,
            to_time: e.to
        });
    }, [])
    const handleClickGoHome = useCallback((value) => {
        setGoHome(value);
        pushRouter({
            go_home: value,
        });
    }, [])
    const handleSelected = useCallback((value) => {
        // setSelected(value);
        if (value) {
            const { from, to } = value;
            setStartDate(from);
            setEndDate(to);
            setLoading(true)
            // dispatch(get_master_loading());
            pushRouter(from ? {
                from_date: moment(from).format("YYYY-MM-DD"),
                to_date: to ? moment(to).format("YYYY-MM-DD") : moment(from).format("YYYY-MM-DD")
            } : { from_date: '', to_date: '' });
        } else {
            setLoading(true)
            // dispatch(get_master_loading());
            setEndDate('');
            pushRouter({
                from_date: moment(startDate).format("YYYY-MM-DD"),
                to_date: moment(startDate).format("YYYY-MM-DD")
            });
        }

    }, [startDate]);
    const selected = useMemo(() => {
        return { from: startDate ? startDate : undefined, to: endDate ? endDate : undefined };
    }, [startDate, endDate]);
    const title = useMemo(() => {
        let text = props?.currentService
            ? (!props.city
                ? props?.currentService[`without_city_title_${props.language}`]
                : props?.currentService[`title_${props.language}`])
            : '';
        if (props?.currentService) {
            text = replaceall('<<CITY>>', props.city || '', text);
            text = replaceall('<<CITYSLUG>>', props.slug || '', text);
			text = replaceall('<<SERVICESLUG>>', props.currentService?.[`slug_${props.language}`] || '', text);
        } else text = '';
        return text;
    }, [props]);
    const mastersDescription = useMemo(() => {
        let description = props.descriptionTexts ? props.descriptionTexts[`text_${props?.language}`] : '';
        if (description !== '') {
            if (props.city && props.currentService) {
                let city = props.city;
                city = city[0].toUpperCase() + city.substring(1);
                description = replaceall('<<CITY>>', city, description);
                description = replaceall('<<SERVICE>>', translate_word(props.currentService, props?.language), description);
                description = replaceall('<<CATEGORY>>', translate_word(props.currentService.category, props?.language), description);
				description = replaceall('<<SERVICESLUG>>', props.currentService?.[`slug_${props.language}`] || '', description);
				description = replaceall('<<LOCAL>>', props.language || '', description);
            } else if (props.city) {
                let city = props.city;
                city = city[0].toUpperCase() + city.substring(1);
                description = replaceall('<<CITY>>', city, description);
				description = replaceall('<<SERVICE>>', translate_word(props.currentService, props?.language), description);
				description = replaceall('<<SERVICESLUG>>', props.currentService?.[`slug_${props.language}`] || '', description);
				description = replaceall('<<LOCAL>>', props.language || '', description);
            } else if (props.currentService) {
                description = replaceall('<<SERVICE>>', translate_word(props.currentService, props?.language), description);
                description = replaceall('<<CATEGORY>>', translate_word(props.currentService.category, props?.language), description);
				description = replaceall('<<SERVICESLUG>>', props.currentService?.[`slug_${props.language}`] || '', description);
				description = replaceall('<<LOCAL>>', props.language || '', description);
            }
            description = replaceall('<<CITYSLUG>>', props.slug || '', description);
			description = replaceall('<<SERVICE>>', translate_word(props.currentService, props?.language), description);
			description = replaceall('<<SERVICESLUG>>', props.currentService?.[`slug_${props.language}`] || '', description);
			description = replaceall('<<LOCAL>>', props.language || '', description);
        }

        return description;
    }, [props.descriptionTexts]);
    const pageDescription = useMemo(() => {
        let description = props?.currentService
            ? (!props.city
                ? props?.currentService[`without_city_${props.language}`]
                : props?.currentService[`description_${props.language}`])
            : '';
        if (description !== '') {
            if (props.city && props.currentService) {
                let city = props.city;
                city = city[0].toUpperCase() + city.substring(1);
                description = replaceall('<<CITY>>', city, description);
				description = replaceall('<<SERVICE>>', translate_word(props.currentService, props?.language), description);
				description = replaceall('<<SERVICESLUG>>', props.currentService?.[`slug_${props.language}`] || '', description);
				description = replaceall('<<LOCAL>>', props.language || '', description);

            } else if (!props.city) {
                description = replaceall('<<CITY>>', '', description);
				description = replaceall('<<SERVICE>>', translate_word(props.currentService, props?.language), description);
				description = replaceall('<<SERVICESLUG>>', props.currentService?.[`slug_${props.language}`] || '', description);
				description = replaceall('<<LOCAL>>', props.language || '', description);
            }
            description = replaceall('<<CITYSLUG>>', props.slug || '', description);
			description = replaceall('<<SERVICE>>', translate_word(props.currentService, props?.language), description);
			description = replaceall('<<SERVICESLUG>>', props.currentService?.[`slug_${props.language}`] || '', description);
			description = replaceall('<<LOCAL>>', props.language || '', description);
        }
        return description;
    }, [props?.currentService]);

    const router = useRouter();

    const jsonLd = useMemo(() => {
        const results = masters_data.data?.results || [];
        const { totalRating, totalCount, ratedCount } = results.reduce((acc, { rating, ratingCount }) => {
            if (rating > 0) {
                acc.totalRating += rating;
                acc.ratedCount++;
            }
            acc.totalCount += ratingCount;
            return acc;
        }, { totalRating: 0, totalCount: 0, ratedCount: 0 });

        const averageRatings = ratedCount ? totalRating / ratedCount : 0;

        const currentService = props.currentService || {};
        const languageSlug = currentService[`slug_${props.language}`];
        const offersUrl = `${props.absoluteUrl}/${i18n.language}${router.asPath}`;

        return productSchema({
            name: title,
            image: currentService.icon,
            description: mastersDescription,
            sku: languageSlug,
            offersUrl,
            offersPrice: 0,
            ratingValue: averageRatings,
            ratingCount: totalCount
        })
    }, [props.slug])
    const pageTitle = useMemo(() => {
        let title = props?.currentService ? props?.currentService[`title_${props.language}`] : '';
        if (title !== '') {
            if (props.city && props.currentService) {
                let city = props.city;
                city = city[0].toUpperCase() + city.substring(1);
                title = replaceall('<<CITY>>', city, title);

            } else if (!props.city) {
                title = replaceall('<<CITY>>', '', title);
            }
        }
        return title;
    }, [props?.currentService]);
    const pushRouter = (data) => {
        const params = queryString.parse(location.search);
        const stringified = queryString.stringify({ ...params, ...data });
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + stringified;
        // window.history.pushState({ path: newurl }, '', newurl);
        router.push(newurl);
    };

    useEffect(() => {
        if (masters_data.data?.results.length > 0) {
            dispatch(get_closest_masters_posts({
                "masters": masters_data.data?.results.map((el) => el.master_id),
                "slug": props.currentService?.slug,
                cb: () => setLoading(false)
            }))
        } else if (loading) {
            setLoading(false)
        }

    }, [masters_data.data?.results]);
    const MapCont = show_map ? memo(dynamic(() => import('../../components/MapCont'))) : <></>;
    const mapCenter = useMemo(() => {
        return [
            city_position ? city_position.lat : (center ? center.lat : DEFAULT_LAT),
            city_position ? city_position.lng : (center ? center.lng : DEFAULT_LNG)]
    }, [city_position, center])
    // const meta = [`${props.meta_file?.DESCRIPTION}`, `${props.city ? props.city : ""}`, `${props.service ? props.service : ""}`];
    return (
        <MainLayout
            // meta={meta.join(" | ")}
            language={props?.language}
            meta={mastersDescription}
            title={title}
            token={props.token}
            {...(props.slug && { json_ld: jsonLd })}
            onChange={(value) => master_saga_act({ search: value, offset: "" })}
            user_image={user ? user?.image : ""}
            id={user ? user?.id : ""}>
            <main className="container" id="map">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"
                        ><Link as={`/${props.language}`} href={`/${props.language}`}><a>{t("main")}</a></Link>
                        </li>
                        {props.city && <li className="breadcrumb-item"
                        >
                            <Link href={`/${props.language}/masters/?city=${props.slug}`}>{`${t("beauticiansIn")} ${props.city[0].toUpperCase() + props.city.substring(1)}`}</Link>
                        </li>}
                        {props.service && <li className="breadcrumb-item"
                        ><Link as={`/${props.language}/masters/${props.currentService[`slug_${props.language}`]}`} href="{`/${props.language}/${props.currentService[`slug_${props.language}`]}`}"><a>{translate_word(props.currentService, props?.language)}</a></Link>
                        </li>}
                        <li className="breadcrumb-item active" aria-current="page">{t("favoriteMasterLabelMaster2")}</li>
                    </ol>
                </nav>
                <div className='masters'>
                    <div className="w-100 masters">
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            id="master_service_modal"
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">
                                {/* {t('youMustLogin')} */}
                                There is no such service
                            </DialogTitle>

                            {/* <DialogActions className={styles.master_service_modal_buttons}>
                                <Button autoFocus>Close</Button>
                            </DialogActions> */}
                        </Dialog>
                        <div className="w-100 d-flex z-index-10000 flex-column gap-2 flex-md-row align-items-md-center">
                            <Autocomplete
                                id="combo-box-demo1"
                                className={styles.masters_filter}
                                getOptionLabel={(option) => translate_word(option, props?.language)}
                                groupBy={(option) => translate_word(option?.category, props?.language)}
                                renderOption={(props2, option) => {
                                    return (
                                        <li {...props2}>
                                            {translate_word(option, props?.language)}
                                        </li>
                                    );
                                }}
                                renderGroup={(params) => {
                                    return <li key={params.key}>
                                        <GroupHeader>{params.group}</GroupHeader>
                                        <GroupItems>{params.children}</GroupItems>
                                        {/* <div>{params?.group}</div>
                                    {params?.children.map((el, key) => <div key={key}>{el?.key}</div>)} */}
                                    </li>;
                                }}
                                defaultValue={props?.currentService ? props?.currentService : null}
                                // onChange={(event, values) => window.location = (`/masters/${values.slug}/${values.id}${props.city ? '?city=' + props.city : ''}`)}
                                onChange={(event, values) => {
                                    if (values && values[`slug_${props.language}`]) {
                                        // handleChangeService(values);
                                        // dispatch(get_master_loading());
                                        setLoading(true)
                                        router.push(`/${props.language}/masters/${values[`slug_${props.language}`]}/${props.slug ? '?city=' + props.slug : ''}`);
                                    } else {
                                        router.push(`/${props.language}/masters/${props.slug ? '?city=' + props.slug : ''}`);
                                    }
                                }}
                                options={category_array || []}
                                sx={{ width: '35%' }}
                                renderInput={(params) => <TextField {...params} label={t('serviceTitleLabel')} />}
                            />
                            <div className={`d-flex justify-content-between align-items-center ${styles.citySelectCont}`} >
                                <div className={styles.citySelect}>
                                    <Autocomplete
                                        noOptionsText={t('no_option')}
                                        loading={service_data?.city?.city_loading}
                                        id="combo-box-demo2"
                                        className={styles.masters_filter}
                                        getOptionLabel={(option) => option?.title_fr}
                                        renderOption={(props2, option) => {
                                            return (
                                                <li {...props2}>{option?.title_fr}</li>
                                            );
                                        }}
                                        // defaultValue={props?.currentService ? props?.currentService : null}
                                        onChange={(event, values) => {
                                            setLoading(true)
                                            pushRouter({ city: values?.slug });
                                            setCity(values?.title_en)
                                        }}
                                        onInputChange={(e, v) => {
                                            if (v.length > 0) {

                                                clearTimeout(timer);
                                                timer = setTimeout(() => get_city_by_search(v), WAIT_INTERVAL);
                                            }
                                        }}
                                        options={service_data?.city?.results ? service_data?.city?.results : []}
                                        // sx={{ width: '35%' }}
                                        renderInput={(params) => <TextField {...params} label={t('yourCityLabel')} />}
                                    />
                                </div>
                                <div style={{ width: '50%', marginLeft: '5px' }} className='d-flex d-md-none justify-content-between align-items-center'>
                                    <span className={styles.sendEmailLabel}>{t("goHome")}</span>
                                    <SwitchCont
                                        value={goHome}
                                        handleChange={handleClickGoHome}
                                    />
                                </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <CustomDayPicker
                                    selected={selected}
                                    setSelected={handleSelected}
                                />
                                <CustomTimePicker
                                    selected={selectedTime}
                                    setSelected={handleSelectTime}
                                />
                            </div>
                            <div style={{ width: '120px', marginBottom: "10px" }} className='d-none d-md-flex justify-content-between align-items-center'>
                                <span className={styles.sendEmailLabel}>{t("goHome")}</span>
                                <SwitchCont
                                    value={goHome}
                                    handleChange={handleClickGoHome}
                                />
                            </div>
                        </div>
                        {loading && <LoadingLayer />}
                        <div className={styles.selected_masters_const}>
                            {props.cityError && <CitiesList language={props?.language} />}
                            {masters_data.data?.results && masters_data.data?.results.length === 0 && !props.cityError
                                ? <div className={styles.deselected_masters}>
                                    <div className={styles.no_selected}>
                                        <span>{t("not_selected_masters")}</span>
                                        <span>{t("masters_suit")}</span>
                                        <MainButton onClick={() => handleClick(`/masters/?city=${my_city.toLowerCase()}`)} title={t("findMasterLabel")} />
                                    </div>
                                    <div className={styles.no_selected}>
                                        <span>{t("not_masters_title")}</span>
                                        <span>{t("not_masters_text")}</span>
                                        <div className="d-flex w-100 align-items-center justify-content-center">
                                            <a target='blank' href='https://apps.apple.com/us/app/beautycils/id1611889051'>
                                                <div style={{ backgroundImage: "url(" + "/landingbottom1.svg" + ")" }}
                                                     className={styles.section_button}>
                                                </div>
                                            </a>
                                            <a target='blank' href='https://play.google.com/store/apps/details?id=com.beautycils.app'>
                                                <div style={{ backgroundImage: "url(" + "/landingbottom2.svg" + ")" }}
                                                     className={styles.section_button}>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div> : <div className={styles.selected_masters}>
                                    {masters_data.data?.results?.map((item, index) => {
                                        return <div className="masters cards-cont" key={index}>
                                            <SelectedMastersMobile
                                                add_favorite_masters={() => item.is_favorite
                                                    ? add_favorite_masters({
                                                        master: item?.master_id,
                                                        user: user.id,
                                                        token: props.token,
                                                    })
                                                    : remove_favorite_masters({
                                                        master: item?.master_id,
                                                        user: user.id,
                                                        token: props.token,
                                                    })
                                                }
                                                geolocation={settings.data.geolocation}
                                                lng={props.lng}
                                                lat={props.lat}
                                                id={item?.master_id}
                                                rating={item?.rating}
                                                image={item?.image ? item?.image : "/profile-user.svg"}
                                                first_name={item?.first_name}
                                                last_name={item?.last_name}
                                                username={item?.master?.user.username}
                                                profession={item?.services}
                                                address={{ lat: item?.latitude, lng: item?.longitude }}
                                                review_count={item?.ratingCount}
                                                loc={item?.master?.master_work_address?.map((item) => item?.work_address)}
                                                single_address={item?.work_address_name}
                                                selected={item?.master?.is_favorite}
                                                price={item?.master?.price}
                                                language={props?.language}
                                                next_free_days={item?.next_free_days}
                                            />

                                            <SelectedMasters2
                                                add_favorite_masters={() => !item?.master.is_favorite
                                                    ? add_favorite_masters({
                                                        master: item?.master.id,
                                                        user: user.id, token: props.token,
                                                    })
                                                    : remove_favorite_masters({
                                                        master: item?.master.id,
                                                        user: user.id,
                                                        token: props.token,
                                                    })
                                                }
                                                onClick={() => get_room(item?.master.id)}
                                                geolocation={settings.data.geolocation}
                                                lng={props.lng}
                                                lat={props.lat}
                                                id={item?.master_id}
                                                rating={item?.rating}
                                                image={item?.image ? item?.image : "/profile-user.svg"}
                                                first_name={item?.first_name}
                                                last_name={item?.last_name}
                                                username={item?.username}
                                                profession={item?.services}
                                                address={{ lat: item?.latitude, lng: item?.longitude }}
                                                review_count={item?.ratingCount}
                                                loc={item?.master?.master_work_address?.map((item) => item?.work_address)}
                                                single_address={item?.work_address_name}
                                                selected={item?.master?.is_favorite}
                                                language={props?.language}
                                                next_free_days={item?.next_free_days}
                                            />
                                        </div>;
                                    })}
                                </div>}
                            {show_map && !props.cityError && <div className={styles.map_cont}>
                                <div style={{ width: '100%', borderRadius: "10px", overflow: "hidden" }}>
                                    <MapCont
                                        startDate={startDate}
                                        endDate={endDate}
                                        selectedTime={selectedTime}
                                        goHome={goHome}
                                        currentService={props?.currentService}
                                        setLoader={() => setLoading(true)}
                                        onChange={(data) => {
                                            // if (loading) {
                                            // handleGetMasters(data);
                                            // }
                                        }}
                                        center={mapCenter}
                                    />

                                </div>
                            </div>}
                        </div>


                        <div className={styles.closestMastersPosts}>
                            {closestMastersPosts?.map((el, ind) => {
                                return <MastersPost
                                    key={ind}
                                    item={el}
                                    language={props.language}
                                    loggedIn={props.loggedIn}
                                    token={props.token}
                                />
                            })}
                        </div>

                        <div className="w-100 home-slider-cont article-slider-cont">
                            {posts_slider?.is_article && posts_slider?.is_article.length > 0 && <Slider {...settingsFirstSlider}>
                                {posts_slider?.is_article?.map((item, index) => {
                                    return <div
                                        key={index}
                                        onClick={() => router.push(`/${props.language}/article/${item?.id}`)}
                                        className={styles.homeSliderImageContainer}>
                                        <img src={item?.main_image} className={styles.homeSliderImage} />
                                        <div className={styles.containerTextButton}>
                                            <h1 className={styles.heading}>{item?.title}</h1>
                                        </div>
                                    </div>
                                })}
                            </Slider>}
                            {posts_slider?.no_article && posts_slider?.no_article.length > 0 && <Slider {...settingsSecondSlider}>
                                {posts_slider?.no_article?.map((item, index) => {
                                    return <div
                                        key={index}
                                        onClick={() => router.push(`/${props.language}/article/${item?.id}`)}
                                        className={styles.homeSliderSecondImageContainer}>
                                        <img src={item?.main_image} className={styles.homeSliderImage} />
                                        <div className={styles.containerTextButton}>
                                            <h1 className={styles.heading}>{item?.title}</h1>
                                        </div>
                                    </div>
                                })}
                            </Slider>}
                        </div>

                        {!masters_data.loading && <div className={styles.mastersDesc}>
                            {/* {props?.currentService[`title_${props.language}`] && <h2>{pageTitle}</h2>} */}
                            {props?.currentService && props?.currentService[`description_${props.language}`] && props.city && props.service && <div className='mt-3' dangerouslySetInnerHTML={{ __html: pageDescription }} />}
                            {props?.currentService && props?.currentService[`without_city_${props.language}`] && !props.city && <div className='mt-3' dangerouslySetInnerHTML={{ __html: pageDescription }} />}
                        </div>}

                        <div className="d-flex flex-wrap gap-3">
                            {props?.currentService?.[`slug_${i18n.language}`] && closestCities.map((el, ind) => {
                                return <Link
                                    key={ind}
                                    href={`/${props.language}/masters/${props?.currentService[`slug_${i18n.language}`]}/?city=${el.slug}`}
                                >
                                    <a className={styles.city_links}
                                    >{`${props?.currentService[`name_${i18n.language}`]} ${t('in')} ${el[`title_${i18n.language}`]}`}</a>
                                </Link>
                            })}
                        </div>
                    </div>
                </div>
            </main>
        </MainLayout>
    );
}

export default Masters;
